export const isServerSide = () => typeof window === 'undefined' || typeof document === 'undefined';
